import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { EAZZY_CLIENTS } from '../../models/landing.model';
import { NotificationsService } from '../../services/notifications.service';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false
})
export class LandingComponent implements OnInit {
  /**
   * indica si se debe mostrar la alerta
   */
  isShowAlert = false;
  /**
   * Listado de logos de clientes
   */
  readonly clients = EAZZY_CLIENTS;
  /**
   * Contact form
   */
  emailForm = this.formBuilder.group({
    full_name: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    phone_number: new UntypedFormControl('', [Validators.required]),
    message: new UntypedFormControl('', [])
  });
  constructor(
    private formBuilder: UntypedFormBuilder,
    private emailService: NotificationsService
  ) { }

  ngOnInit(): void {
    // window.location.href = 'https://eazzymenu.web.app/#/';
  }

  hideMenu(): void {
    const elemento = document.getElementById('navbarSupportedContent');
    if (elemento) {
      elemento.classList.remove('show');
    }
  }

  /**
   * Hace scroll hasta la seccion indicada
   *
   * @id nombre de la seccion
   */
  scrollTo(id: string): void {
    this.hideMenu();
    const sectionSelect = document.getElementById(id);
    if (sectionSelect) {
      sectionSelect.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  onSubmit() {
    if (this.emailForm.valid) {
      const message = `
      <h1>Mensaje de contacto</h1>
<br>
<p><strong>Nombre:</strong> ${this.emailForm.value.full_name}</p>
<br>
<p><strong>Contacto:</strong> ${this.emailForm.value.phone_number}</p>
<br>
<p><strong>Correo:</strong> ${this.emailForm.value.email}</p>
<br>
<p><strong>Mensaje:</strong> ${this.emailForm.value.message}</p>
      `;
      this.emailService.sendEmail(
        this.emailForm.value.email,
        '',
        `Contacto - ${this.emailForm.value.full_name}`,
        message
      ).subscribe(() => {
        this.isShowAlert = true;
        setTimeout(() => {
          this.isShowAlert = false;
        }, 2000);
        this.emailForm.reset();
      });
    }
  }

}
